<template>
   <div class="container-wrapper">
      <div class="breadcrumb-wrapper">高校管理</div>

      <div class="search-wrapper">
         <el-select
            style="width: 500px;"
            placeholder="请选择高校"
            size="small"
            filterable
            clearable
            v-model="queryForm.rootUnid"
            @change="onSchoolChange"
         >
            <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.rootUnid">
            </el-option>
         </el-select>

         <div class="signed-filter">
            <span class="signed-filter__label">学校是否签约</span>
            <el-radio-group v-model="signedFilter" class="signed-filter__radios" size="small" @change="handleSearch">
               <el-radio label="">全部</el-radio>
               <el-radio label="1">正式签约</el-radio>
               <el-radio label="2">意向签约</el-radio>
               <el-radio label="0">未签约</el-radio>
            </el-radio-group>
         </div>
      </div>

      <div class="content-wrapper">
         <el-table :data="tableData" border style="width: 100%">
            <el-table-column align="center" label="序号" type="index" width="80"></el-table-column>
            <el-table-column align="center" label="学校名称" prop="name"></el-table-column>
            <el-table-column align="center" label="学校类型">
               <template scope="scope"> {{ scope.row.schoolType == 4 ? '高中' : '大学' }}</template>
            </el-table-column>
            <el-table-column align="center" label="学校是否签约">
               <template scope="{ row }">{{ signedText(row) }}</template>
            </el-table-column>
            <el-table-column align="center" label="校区数量">
               <template scope="{ row }">{{ row.campusNum }}</template>
            </el-table-column>
            <el-table-column align="center" label="是否启用一体机">
               <template scope="{ row }">
                  {{ (row.config && row.config.enableOnePC) ? "是" : "否" }}
               </template>
            </el-table-column>
            <el-table-column align="center" label="场馆运动时长监控">
               <template scope="{ row }">{{ handleSportTimeConfig(row) }}</template>
            </el-table-column>
            <el-table-column align="center" label="硬件防作弊">
               <template scope="{ row }">
                  {{ (row.config && row.config.hardwareCollection) ? "开启" : "关闭" }}
               </template>
            </el-table-column>
            <el-table-column align="center" label="教师管理人脸">
               <template scope="{ row }">
                  {{ (row.config && row.config.enableTeacherInputFace) ? "开启" : "关闭" }}
               </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="200">
               <template scope="{ row }">
                  <el-button type="text" size="small" @click="editschool(row)">编辑</el-button>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <div class="pagination-wrapper">
         <el-pagination
            layout="total, prev, pager, next"
            :current-page="queryForm.pageNum"
            :page-size="queryForm.pageSize"
            :total="total"
            @current-change="handlePageChange"
         />
      </div>
   </div>
</template>

<script>
export default {
   data() {
      return {
         loading: false,
         schoolList: [],
         signedFilter: "",
         queryForm: {
            rootUnid: '',
            pageNum: 1,
            pageSize: 10,
         },
         /** 列表总条数（接口 totalNum），用于分页组件 total */
         total: 0,
         tableData: [],
      };
   },

   mounted() {
      this.queryAllSchool();
      this.querySchoolList();
   },

   methods: {
      // 获取所有学校
      queryAllSchool() {
         this.loading = true;
         this.$http({
            method: "get",
            url: this.$util.domain + "/adminapi/v1/basicTools/schoolList",
         }).then((response) => {
            if (response.data.error == 10000) {
               this.schoolList = response.data.data;
               if (this.schoolList.length > 0) {
                  let item = this.schoolList[this.schoolList.length - 1];
               }
            } else {
               this.$util.errorMsg(response.data.message);
            }
         }).finally(() => {
            this.loading = false;
         });
      },

      // 查询学校列表
      querySchoolList() {
         this.loading = true;
         const body = { ...this.queryForm };
         if (this.signedFilter !== "" && this.signedFilter != null) {
            body.isSigned = Number(this.signedFilter);
         } else {
            // 接口约定：不传 isSigned 则查询全部
            delete body.isSigned;
         }
         this.$http({
            method: "post",
            url: this.$util.domain + "/adminapi/v1/basicTools/schoolPageList",
            body,
         }).then((response) => {
            if (response.body.error == 10000) {
               const data = response.body.data || {};
               this.total = data.totalNum != null ? data.totalNum : 0;
               this.tableData = data.list || [];
            } else {
               this.total = 0;
               this.tableData = [];
               this.$util.errorMsg(response.data.message);
            }
         }).finally(() => {
            this.loading = false;
         });
      },

      /** 切换高校时从第一页重新拉取 */
      onSchoolChange() {
         this.queryForm.pageNum = 1;
         this.querySchoolList();
      },

      handlePageChange(page) {
         this.queryForm.pageNum = page;
         this.querySchoolList();
      },

      handleSearch() {
         this.queryForm.pageNum = 1;
         this.querySchoolList();
      },

      // 点击编辑按钮
      editschool(row) {
         this.$util.setStore('collegeManageRow', row);
         this.$router.push({
            path: '/xiaoyuan/college/manage/detail'
         })
      },

      // 处理运动时长监控开关
      handleSportTimeConfig(row) {
         if (row.sportTimeConfigModel) {
            const model = row.sportTimeConfigModel;
            return model.openVenueSport == 1 ? '开启' : '关闭';
         }
         return '关闭';
      },

      // 是否签约文案：1=正式签约，2=意向签约，0=未签约（接口可能在 row.config 或 row 顶层返回）
      signedText(row) {
         const raw =
            row && row.config && row.config.isSigned != null ? row.config.isSigned : row && row.isSigned != null ? row.isSigned : 1;
         const n = Number(raw);
         if (n === 1) return "正式签约";
         if (n === 2) return "意向签约";
         if (n === 0) return "未签约";
         return "—";
      }
   },

   beforeRouteEnter(to, from, next) {
      if (from.path.includes('/xiaoyuan/college/manage/detail')) {
         to.meta.refresh = true;
      }
      next();
   },
   activated() {
      if (this.$route.meta.refresh) {
         this.$route.meta.refresh = false;
         this.querySchoolList();
      }
   }
};
</script>

<style scoped>
.search-wrapper {
   display: flex;
   align-items: center;
   gap: 12px;
   flex-wrap: wrap;
}

.signed-filter {
   display: inline-flex;
   align-items: center;
   gap: 10px;
   margin-left: 12px;
   align-self: center;
}

.signed-filter__label {
   color: #606266;
   font-size: 14px;
   white-space: nowrap;
}

.signed-filter__radios >>> .el-radio {
   margin-right: 12px;
}

.signed-filter__radios >>> .el-radio:last-child {
   margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// CollegeManage.vue?751dbb8f